import { atom } from 'jotai';

/**
 * Pont (front-only) entre la sync catégorie Shopify lancée depuis l'alert
 * sidebar et la catégorisation IA en fallback orchestrée au niveau page.
 *
 * La mutation Shopify est asynchrone (bulk) et ne renvoie que le `dealId` : on
 * ne peut donc pas corréler un `ds_…`. L'alert sidebar arme un "pending" avec la
 * sélection ; `useDealItems` bumpe le signal à chaque `datasourceProcessed` (le
 * seul signal terminal Shopify fiable) ; l'orchestrateur consomme le pending et
 * envoie les items toujours sans catégorie vers l'IA.
 */
export const pendingShopifyCategoryFallbackAtom = atom<{
  dealId: string;
  itemIds: string[];
} | null>(null);

/** Compteur incrémenté à chaque `datasourceProcessed` reçu par la subscription. */
export const datasourceProcessedSignalAtom = atom(0);
